import classNames from "classnames/bind";
import React from "react";
import { ConversationMessageCopyButton } from "./ConversationMessageCopyButton";
import styles from "./InvestigationDetailPage.module.scss";

const cx = classNames.bind(styles);

export type CopyableConversationMessageBubbleProps = {
  content: string;
  isUserMessage: boolean;
  bubbleClassName: string;
  testId?: string;
  children: React.ReactNode;
};

/**
 * Wraps a conversation message bubble with an optional copy action below
 * when the message has non-empty content.
 */
export const CopyableConversationMessageBubble = ({
  content,
  isUserMessage,
  bubbleClassName,
  testId,
  children,
}: CopyableConversationMessageBubbleProps) => {
  const trimmedContent = content.trim();
  const shouldShowCopyButton = Boolean(trimmedContent);

  return (
    <div
      className={cx("conversation-feed__message-block", {
        "conversation-feed__message-block--user": isUserMessage,
      })}
    >
      <div
        className={bubbleClassName}
        data-testid={testId}
      >
        {children}
      </div>
      {shouldShowCopyButton ? (
        <ConversationMessageCopyButton
          content={trimmedContent}
          isUserMessage={isUserMessage}
        />
      ) : null}
    </div>
  );
};
